export const toLocalDate = (date: string | Date): string => {
    return new Date(date).toLocaleString().split(',')[0]
}

export const fromLocalDate = (date: string): Date => {
    const arrayFromDate = date.split('.')
    return new Date(`${arrayFromDate[1]}-${arrayFromDate[0]}-${arrayFromDate[2]}`)
}